import React, { useState } from "react";
import Section from "./layouts/Section";
import { Link } from "react-router-dom";
import PageLayout from "./layouts/PageLayout";

function Shop() {
  // Simple local pagination state (for UI only)
  const [page, setPage] = useState(1);
  const totalPages = 3;
  const goto = (n) => setPage(n);
  const prev = () => setPage((p) => Math.max(1, p - 1));
  const next = () => setPage((p) => Math.min(totalPages, p + 1));

  return (
    <PageLayout
      title="Phone Accessories Shop | Cases, Chargers, Screen Protectors | Cell Station"
      description="Shop premium phone cases, chargers, earbuds, and screen protectors at Cell Station. In-store pickup in Willow Grove, PA."
      url="https://www.icellstation.com/shop"
    >
      <Section title={"Shop"}>
        <section className="section page-content">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="row">
                  {/* Product 1 */}
                  <div className="col-md-6">
                    <div className="card border-0 product-item shadow-sm mb-30">
                      <img
                        className="card-img-top border-bottom"
                        src="https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=400&h=300&fit=crop"
                        alt="iPhone 13 Pro Max 256GB" loading="lazy"
                      />
                      <div className="card-body">
                        <div className="show-on-hover">
                          <Link
                            to="/cart"
                            className="btn btn-primary rounded-pill initiate-scripts"
                          >
                            Add to Cart <span className="fas fa-cart-plus" />
                          </Link>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-uppercase font-w-600">
                            computer products
                          </small>
                          <div className="rating small text-primary d-flex">
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                          </div>
                        </div>
                        <Link to="/shop-single">
                          <h5 className="text-dark font-w-600 mt-10 mb-10">
                            iPhone 13 Pro Max 256GB
                          </h5>
                        </Link>
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="font-w-700 text-dark font-secondery">
                            $599
                          </h5>
                          <Link
                            to="/cart"
                            className="text-primary font-w-600 text-uppercase initiate-scripts"
                          >
                            Add to cart +
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product 2 */}
                  <div className="col-md-6">
                    <div className="card border-0 product-item shadow-sm mb-30">
                      <img
                        className="card-img-top border-bottom"
                        src="https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&h=300&fit=crop"
                        alt="MacBook Pro Laptop" loading="lazy"
                      />
                      <div className="card-body">
                        <div className="show-on-hover">
                          <Link
                            to="/cart"
                            className="btn btn-primary rounded-pill initiate-scripts"
                          >
                            Add to Cart <span className="fas fa-cart-plus" />
                          </Link>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-uppercase font-w-600">
                            Laptop products
                          </small>
                          <div className="rating small text-primary d-flex">
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                          </div>
                        </div>
                        <h5 className="text-dark font-w-600 mt-10 mb-10">
                          MacBook Pro 13" 256GB
                        </h5>
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="font-w-700 text-dark font-secondery">
                            $899.00
                          </h5>
                          <Link
                            to="/cart"
                            className="text-primary font-w-600 text-uppercase initiate-scripts"
                          >
                            Add to cart +
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product 3 */}
                  <div className="col-md-6">
                    <div className="card mobile border-0 product-item shadow-sm mb-30">
                      <img
                        className="card-img-top border-bottom"
                        src="https://images.unsplash.com/photo-1544866092-1935c5ef2a8f?w=400&h=300&fit=crop"
                        alt="Samsung Galaxy Phone" loading="lazy"
                      />
                      <div className="card-body">
                        <div className="show-on-hover">
                          <Link
                            to="/cart"
                            className="btn btn-primary rounded-pill initiate-scripts"
                          >
                            Add to Cart <span className="fas fa-cart-plus" />
                          </Link>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-uppercase font-w-600">
                            Mobile phones
                          </small>
                          <div className="rating small text-primary d-flex">
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                          </div>
                        </div>
                        <h5 className="text-dark font-w-600 mt-10 mb-10">
                          Samsung Galaxy S23 Ultra
                        </h5>
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="font-w-700 text-dark font-secondery">
                            $549.00
                          </h5>
                          <Link
                            to="/cart"
                            className="text-primary font-w-600 text-uppercase initiate-scripts"
                          >
                            Add to cart +
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Product 4 */}
                  <div className="col-md-6">
                    <div className="card mobile border-0 product-item shadow-sm mb-30">
                      <img
                        className="card-img-top border-bottom"
                        src="https://images.unsplash.com/photo-1585790050230-5dd28404ccb9?w=400&h=300&fit=crop"
                        alt="iPad Tablet" loading="lazy"
                      />
                      <div className="card-body">
                        <div className="show-on-hover">
                          <Link
                            to="/cart"
                            className="btn btn-primary rounded-pill initiate-scripts"
                          >
                            Add to Cart <span className="fas fa-cart-plus" />
                          </Link>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-uppercase font-w-600">
                            Tablets
                          </small>
                          <div className="rating small text-primary d-flex">
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                            <span className="fas fa-star" />
                          </div>
                        </div>
                        <h5 className="text-dark font-w-600 mt-10 mb-10">
                          iPad Pro 11" 128GB
                        </h5>
                        <div className="d-flex align-items-center justify-content-between">
                          <h5 className="font-w-700 text-dark font-secondery">
                            $699.00
                          </h5>
                          <Link
                            to="/cart"
                            className="text-primary font-w-600 text-uppercase initiate-scripts"
                          >
                            Add to cart +
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Pagination (fixed: buttons instead of invalid anchors) */}
                  <div className="col-md-12">
                    <nav className="pagination-wrapper" aria-label="Pagination">
                      <ul className="pagination justify-content-center">
                        <li>
                          <button
                            type="button"
                            onClick={prev}
                            className="page-link"
                            aria-label="Previous page"
                            disabled={page === 1}
                          >
                            <span className="fas fa-chevron-left" />
                          </button>
                        </li>

                        {[1, 2, 3].map((n) => (
                          <li key={n}>
                            <button
                              type="button"
                              onClick={() => goto(n)}
                              className={`page-link ${
                                page === n ? "active" : ""
                              }`}
                              aria-current={page === n ? "page" : undefined}
                            >
                              {String(n).padStart(2, "0")}
                            </button>
                          </li>
                        ))}

                        <li>
                          <button
                            type="button"
                            onClick={next}
                            className="page-link"
                            aria-label="Next page"
                            disabled={page === totalPages}
                          >
                            <span className="fas fa-chevron-right" />
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-lg-4 mt-5 mt-lg-0">
                <div className="widget widget-search mt-0">
                  <form className="d-flex">
                    <input
                      type="search"
                      className="form-control border-0 shadow-none bg-transparent"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="border-0 bg-transparent"
                      aria-label="Search"
                    >
                      <span className="fas fa-search" />
                    </button>
                  </form>
                </div>
                <div className="widget widget-categoty">
                  <div className="widget-heading">Categoty</div>
                  <ul className="category-list list-unstyled p-4">
                    <li>
                      <span className="fas fa-caret-right mr-2" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        PC Laptop Repair
                      </Link>
                    </li>
                    <li>
                      <span className="fas fa-caret-right mr-2 mt-3" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        Mac Repair
                      </Link>
                    </li>
                    <li>
                      <span className="fas fa-caret-right mr-2 mt-3" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        PC Desktop Repair
                      </Link>
                    </li>
                    <li>
                      <span className="fas fa-caret-right mr-2 mt-3" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        iPhone Repair
                      </Link>
                    </li>
                    <li>
                      <span className="fas fa-caret-right mr-2 mt-3" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        iPad Repair
                      </Link>
                    </li>
                    <li>
                      <span className="fas fa-caret-right mr-2 mt-3" />
                      <Link
                        to="/services"
                        className="text-reset initiate-scripts"
                      >
                        Smartphone Repair
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Section>
    </PageLayout>
  );
}

export default Shop;
